import React from 'react';
import { Container } from './ui/Container';
import { statsData } from '../data/sections';
export function BenefitsStrip() {
  return <section className="border-y border-mp-border bg-mp-dark py-10 md:py-12" data-id="element-23" data-mp="3sqmte65zgy5j">
      <Container data-id="element-24" data-mp="b9ln5xn7bu60">
        <div className="grid grid-cols-2 gap-6 md:grid-cols-4 md:gap-8" data-id="element-25" data-mp="ba4vcmn1v46u">
          {statsData.map(item => <div key={item.copy} className="text-center md:text-left" data-id="element-26" data-mp="6fqx8ch06iyh">
              <p className="font-heading text-2xl uppercase tracking-wide text-mp-lime sm:text-3xl" data-id="element-27" data-mp="k7xbft0lifva">{item.title}</p>
              <p className="mt-1 text-xs text-mp-gray sm:text-sm" data-id="element-28" data-mp="g7dg8uzl1mbs">{item.copy}</p>
            </div>)}
        </div>
      </Container>
    </section>;
}